import { render, staticRenderFns } from "./RegPaymentDetails.vue?vue&type=template&id=8d71391a&scoped=true"
import script from "./RegPaymentDetails.vue?vue&type=script&lang=js"
export * from "./RegPaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./RegPaymentDetails.vue?vue&type=style&index=0&id=8d71391a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71391a",
  null
  
)

export default component.exports